const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function createDemoUsers() {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/auth/create-demo-users`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data = await response.json();

  if (!response.ok || data?.isError) {
    throw new Error(data?.message || data?.payload?.message || "Demo kullanicilar olusturulurken bir hata olustu.");
  }

  const userNames = data?.payload?.userNames || data?.data?.userNames;
  if (!Array.isArray(userNames) || userNames.length === 0) {
    throw new Error("Demo kullanici bilgileri alinamadi.");
  }

  return userNames;
}
